import { defaultTheme } from './default/theme';
import { demonstrationTheme } from './demonstration/theme';
import { demonstrationVivoTheme } from './demonstrationVivo/theme';
import { demonstrationQualicorpTheme } from './demonstrationQualicorp/theme';
import { demonstrationDrConsultaTheme } from './demonstrationDrConsulta/theme';
import { demonstrationVivoavulsoTheme } from './demonstrationVivoavulso/theme';
import { demonstrationYaloTheme } from './demonstrationYalo/theme';
import { demonstrationCmDrConsultaTheme } from './demonstrationCmDrConsulta/theme';
import { demonstrationFamiliaTheme } from './demonstrationFamilia/theme';
import { ifoodTheme } from './ifood/theme';
export default url => {
	const Themes = {
		bancointer: demonstrationVivoTheme,
		bv: demonstrationTheme,
		default: defaultTheme,
		qualicorp: demonstrationQualicorpTheme,
		drconsulta: demonstrationDrConsultaTheme,
		vivoavulso: demonstrationVivoavulsoTheme,
		yalo: demonstrationYaloTheme,
		cmdrconsulta: demonstrationCmDrConsultaTheme,
		familia: demonstrationFamiliaTheme,
		ifood: ifoodTheme
	};

	return Themes[url] || Themes.default;
};
